/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useContext } from "react";
import {
  Form,
  Input,
  Typography,
  Button,
  Alert,
  Modal,
  notification,
} from "antd";
import { FacebookFilled, GooglePlusOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { Redirect, Navigate } from "react-router-dom";
import moment from "moment";

import { facebookSignIn, googleSignIn } from "../../firebase/firebase";
import { UserContext } from "../../Provider/UserProvider";
// import OtpInput from "react-otp-input";
/* CUSTOM COMPONENT */
import {
  Container,
  Content,
  Left,
  Right,
  LoginInput,
  Xlink,
  OTPInput,
} from "./LoginStyle";

/* ACTIONS */
import { login } from "../../action/loginAction";
import { saveLoginData } from "../../action/saveLoginDataAction";
import axios from "axios";
import UserProvider from "../../Provider/UserProvider";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import config from "../../config";
// import { sendForgotPasswordOtp } from '../../action/sendForgotPasswordOtpAction'
import "./Login.css";
const Login = (props) => {
  //CONSTANTS
  const {
    login,
    loginState,
    saveLoginData,
    saveLoginDataState,
    // sendForgotPasswordOtp, sendForgotPasswordOtpState,
  } = props;

  const [form] = Form.useForm();
  const [PasswordForm] = Form.useForm();
  const { Title } = Typography;
  let week = 0;

  //STATES
  const [redirect, setRedirect] = useState({
    value: false,
    url: "",
    state: {},
  });
  const [LoginData, setLoginData] = useState({
    intrests: [],
    highlights_of_the_week_baby: [],
    conseive_status: "",
    gender: "",
    name: "",
    size: "",
    size_img: "",
    week: "",
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [sendResponse, setSendResponse] = useState();
  const [VerifyResponse, setVerifyResponse] = useState();
  const [resetEnable, setResetEnable] = useState(true);
  const [resetNumber, setResetNumber] = useState(false);
  const [counter, setCounter] = useState(0);
  const [passwordData, setPasswordData] = useState({
    username: "",
    otp: [],
    otpNum: "",
    newPassword: "",
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [validated, setValidated] = useState(false);
  // console.log("password data",passwordData)
  
  //Google sign in
  const user = useContext(UserContext);
  const [userRedirect, setUserRedirect] = useState(null);
  // console.log("UserContext",UserContext)
  //FUNCTIONS

  const onFinish = (values) => {
    console.log("Success:", values.username);
    const data = {
      username: values.username,
      password: values.password,
    };
    // console.log(data)
    login(data);
  };

  const handleUsername = (value) => {
    form.setFieldsValue({
      username: value,
    });
    // console.log(value)
  };

  const validateUser = (rule, value) => {
    return new Promise((resolve, reject) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneNumberRegex =
        /^(?:\+?\d{1,3}[-.\s]?)?\(?[6-9]\d{2}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
      if (formSubmitted && !value) {
        reject(new Error("Please enter a email id/phone number"));
      } else if (
        formSubmitted &&
        !emailRegex.test(value) &&
        !phoneNumberRegex.test(value)
      ) {
        reject(new Error("Please enter a valid email id/phone number"));
      } else {
        resolve();
      }
    });
  };

  const handlePassword = (value) => {
    form.setFieldsValue({
      password: value,
    });
    // console.log(value)
  };

  const validatePassword = (rule, value) => {
    return new Promise((resolve, reject) => {
      if (formSubmitted && !value) {
        reject(new Error("Please Enter Password"));
      } else if (formSubmitted && value.length < 8) {
        reject(new Error("Password must contain 8 characters"));
      } else {
        resolve();
      }
    });
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const SendOTP = () => {
    console.log(passwordData);

    if (passwordData.username) {
      const data = {
        username: parseInt(passwordData.username),
      };
      console.log(data);
      var sendOTPRequest = {
        method: "post",
        url: `${config.api.base_url}patient/auth/password/send-reset-otp`,
        // url: "http://localhost:8187/patient/auth/password/send-reset-otp",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(sendOTPRequest)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          setSendResponse(response.data);
          // setResetNumber(true)
          notification["success"]({
            message: response.data.message,
            placement: "bottomRight",
          });
        })
        .catch(function (error) {
          console.log(error);
          notification["error"]({
            message: error.message,
            placement: "bottomRight",
          });
        });
      // sendForgotPasswordOtp(data)
      setTimeout(() => setResetEnable(false), 30000);
      setCounter(30);
    } else {
      console.log(passwordData);
    }
  };

  const ResendOtp = () => {
    setResetEnable(true);
    SendOTP();
  };

  const ConfirmOtp = (username, otp) => {
    let otpnum = parseInt(
      passwordData.otp
        .toString()
        .replace(",", "")
        .replace(",", "")
        .replace(",", "")
        .replace(",", "")
    );
    setPasswordData({ ...passwordData, ["otpNum"]: otpnum });
    setResetNumber(true);
  };

  const move = (e, p, c, n) => {
    console.log(p, c, n);
    var length = document.getElementById(c).value.length;
    var maxlength = document.getElementById(c).getAttribute("maxLength");
    console.log(length, maxlength);
    if (length === parseInt(maxlength)) {
      if (n !== "") {
        document.getElementById(n).focus();
      }
    }
    if (e.key === "Backspace") {
      if (p !== "") {
        document.getElementById(p).focus();
      }
    }
  };

  const SetPassword = () => {
    // let otpnum = parseInt(passwordData.otp.toString().replace(",","").replace(",","").replace(",","").replace(",",""))
    const data = {
      username: passwordData.username,
      otp: passwordData.otpNum,
      password: passwordData.newPassword,
    };
    console.log(data);
    var setPasswordRequest = {
      method: "post",
      url: `${config.api.base_url}patient/auth/password/reset`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(setPasswordRequest)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        setVerifyResponse(response.data);
        setRedirect({
          ...redirect,
          ["value"]: true,
          ["url"]: "/login",
          ["state"]: response.data,
        });
        setIsModalVisible(false);
        notification["success"]({
          message: response.data.message,
          placement: "bottomRight",
        });
      })
      .catch(function (error) {
        console.log("error message", error);
        notification["error"]({
          message: error.message,
          placement: "bottomRight",
        });
      });
  };
  //CALLBACKS

  useEffect(() => {
    // console.log("UseEffect 1")
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  useEffect(() => {
    // console.log("UseEffect 2")
    // console.log(loginState)
    if (loginState.apiState === "success" && loginState.data !== null) {
      loginState.apiState = "";
      localStorage.setItem("LilacPatientToken", loginState.data.token);
      console.log(loginState.data.patient.interest);
      localStorage.setItem(
        "LilacPatient",
        JSON.stringify(loginState.data.patient.patient_id)
      );
      let lmp_d = moment(loginState.data.patient.lmp);
      let lmp_date = lmp_d.format("YYYY-MM-DD");
      localStorage.setItem("lmp", JSON.stringify(lmp_date));
      if (lmp_date != null) {
        var today = moment();
        var lmp_date1 = moment(lmp_date);
        week = today.diff(lmp_date1, "week") + 1;
      }
      localStorage.setItem(
        "lmp_as_of",
        JSON.stringify(loginState.data.patient.lmp_as_of)
      );
      localStorage.setItem("week", JSON.stringify(week));
      localStorage.setItem(
        "name",
        JSON.stringify(loginState.data.patient.name)
      );
      localStorage.setItem(
        "email",
        JSON.stringify(loginState.data.patient.email)
      );
      localStorage.setItem("dob", JSON.stringify(loginState.data.patient.dob));
      localStorage.setItem(
        "phone",
        JSON.stringify(loginState.data.patient.phone)
      );
      localStorage.setItem(
        "gender",
        JSON.stringify(loginState.data.patient.gender)
      );
      localStorage.setItem(
        "tribe",
        JSON.stringify(loginState.data.patient.tribe)
      );
      localStorage.setItem(
        "interest",
        JSON.stringify(loginState.data.patient.interest)
      );
      localStorage.setItem(
        "conceive_status",
        JSON.stringify(loginState.data.patient.conceive_status)
      );

      if (loginState.data.patient.profile_pic) {
        localStorage.setItem(
          "profile_pic",
          JSON.stringify(loginState.data.patient.profile_pic)
        );
      }

      console.log(loginState.data.patient.patient_id);
      console.log(redirect);
      setRedirect({
        ...redirect,
        ["value"]: true,
        ["url"]: "/",
      });

      saveLoginData(loginState.data.patient);
    } else {
      loginState.apiState = "";
    }
  }, [loginState]);

  //google sign up
  useEffect(() => {
    if (user) {
      setUserRedirect("/");
    }
  }, [user]);
  if (userRedirect) {
    <Redirect to={userRedirect} />;
  }

  // console.log(redirect)
  return (
    <div style={{ overflow: "hidden", overflowX: "hidden" }}>
      {redirect.value && (
        <Redirect
          to={{
            pathname: redirect.url,
            state: { referrer: redirect.state },
          }}
        />
      )}
      <div className="container-fluid">
        <div className="row pl-lg-5">
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 pl-lg-5">
            <div className="logos-login">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/svg/Lilac-Insights-Logo1.svg"
                }
                alt=""
              />
            </div>
            <p className="title-login welcome"> Welcome back</p>
            <p className="logpg-login">Please enter your details.</p>
            <Form
              form={form}
              onFinish={onFinish}
              className="p-0 pb-5 pb-sm-0 pb-md-0"
              autocomplete="off"
            >
              <div className="row mt-4">
                <div className="col-sm-10 col-md-10 col-12">
                  <div className="form-group">
                    <label className="lbsc">Email ID/Phone No</label>
                    <Form.Item
                      name="username"
                      rules={[
                        {
                          required: true,
                          validator: validateUser,
                        },
                      ]}
                    >
                      {/* , type: 'email' */}
                      <LoginInput>
                        <Input
                          size="large"
                          placeholder="Email ID/Phone No"
                          onChange={handleUsername}
                        />
                      </LoginInput>
                    </Form.Item>
                  </div>
                </div>
                <div className="col-sm-10 col-md-10 col-12">
                  <div className="form-group">
                    <label className="lbsc">Password</label>
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          validator: validatePassword,
                        },
                      ]}
                    >
                      <LoginInput>
                        <Input.Password
                          size="large"
                          placeholder="Password"
                          onChange={handlePassword}
                          style={{ borderRadius: "5px" }}
                        />
                      </LoginInput>
                    </Form.Item>
                  </div>
                </div>
                <div className="col-sm-10 col-md-10 col-12 text-right">
                  <Form.Item>
                    <Button
                      type={"link"}
                      onClick={showModal}
                      className="regitForgotLbl pr-0"
                    >
                      Forgot Password?
                    </Button>
                  </Form.Item>
                </div>
              </div>
              <div className="row flex-column-reverse flex-sm-row flex-md-row align-items-center">
                <div className="col-sm-10 col-md-10 col-12">
                  {loginState.apiState === "success" && loginState.data == null && (
                    <Alert
                      message={loginState.message}
                      type="error"
                      className="mb-4 errorMsg"
                      showIcon
                    />
                  )}
                  <Form.Item>
                    <button
                      size="large"
                      shape="round"
                      type="primary"
                      htmlType="submit"
                      className="regitBtn"
                      onClick={() => setFormSubmitted(true)}
                    >
                      Sign In
                    </button>
                  </Form.Item>
                </div>
                <div className="col-sm-10 col-md-10 col-12">
                  {/* <div> */}
                  <Form.Item>
                    <ul className="regitButtonList">
                      <li>
                        <UserProvider>
                          <a
                            onClick={async () => {
                              const data = await googleSignIn();
                              console.log(data);
                              // alert("Data")
                              const url = `${config.api.base_url}patient/auth/sign-in?type=social`;
                              //  const response = await axios({
                              //      method: 'post',
                              //      url,
                              //      data:{
                              //      "provider" : data.provider,
                              //      "id" : data.id,
                              //      "email" : data.email,
                              //      },
                              //      headers: {
                              //          "Content-type": "application/json; charset=UTF-8",
                              //      }
                              //  })
                              //  console.log(response)
                              login(data);
                            }}
                            role="button"
                          >
                            <svg
                              width="230"
                              height="27"
                              viewBox="0 0 230 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M21.0005 14.0134C21.0005 13.1275 20.929 12.481 20.7743 11.8105H10.7148V15.8092H16.6195C16.5005 16.8029 15.8577 18.2994 14.4291 19.305L14.4091 19.4389L17.5897 21.9169L17.8101 21.939C19.8338 20.0593 21.0005 17.2938 21.0005 14.0134Z"
                                fill="#4285F4"
                              />
                              <path
                                d="M10.714 24.5501C13.6068 24.5501 16.0354 23.5923 17.8092 21.9402L14.4283 19.3063C13.5235 19.9408 12.3092 20.3838 10.714 20.3838C7.88071 20.3838 5.47597 18.5042 4.61875 15.9062L4.4931 15.917L1.18583 18.491L1.14258 18.6119C2.90446 22.1317 6.52352 24.5501 10.714 24.5501Z"
                                fill="#34A853"
                              />
                              <path
                                d="M4.61899 15.905C4.39281 15.2346 4.2619 14.5162 4.2619 13.774C4.2619 13.0316 4.39281 12.3133 4.60709 11.6429L4.6011 11.5001L1.25239 8.88477L1.14283 8.93718C0.41667 10.3978 0 12.038 0 13.774C0 15.5099 0.41667 17.1501 1.14283 18.6107L4.61899 15.905Z"
                                fill="#FBBC05"
                              />
                              <path
                                d="M10.714 7.16628C12.7259 7.16628 14.083 8.04024 14.8568 8.77059L17.8806 5.80148C16.0235 4.06552 13.6068 3 10.714 3C6.52351 3 2.90446 5.41835 1.14258 8.93813L4.60684 11.6439C5.47596 9.04593 7.8807 7.16628 10.714 7.16628Z"
                                fill="#EB4335"
                              />
                              <path
                                d="M36.774 13.718C36.774 12.494 37.05 11.396 37.602 10.424C38.154 9.44 38.904 8.672 39.852 8.12C40.812 7.568 41.874 7.292 43.038 7.292C44.406 7.292 45.6 7.622 46.62 8.282C47.64 8.942 48.384 9.878 48.852 11.09H46.89C46.542 10.334 46.038 9.752 45.378 9.344C44.73 8.936 43.95 8.732 43.038 8.732C42.162 8.732 41.376 8.936 40.68 9.344C39.984 9.752 39.438 10.334 39.042 11.09C38.646 11.834 38.448 12.71 38.448 13.718C38.448 14.714 38.646 15.59 39.042 16.346C39.438 17.09 39.984 17.666 40.68 18.074C41.376 18.482 42.162 18.686 43.038 18.686C43.95 18.686 44.73 18.488 45.378 18.092C46.038 17.684 46.542 17.102 46.89 16.346H48.852C48.384 17.546 47.64 18.476 46.62 19.136C45.6 19.784 44.406 20.108 43.038 20.108C41.874 20.108 40.812 19.838 39.852 19.298C38.904 18.746 38.154 17.984 37.602 17.012C37.05 16.04 36.774 14.942 36.774 13.718ZM55.5923 20.162C54.6683 20.162 53.8283 19.952 53.0723 19.532C52.3283 19.112 51.7403 18.518 51.3083 17.75C50.8883 16.97 50.6783 16.07 50.6783 15.05C50.6783 14.042 50.8943 13.154 51.3263 12.386C51.7703 11.606 52.3703 11.012 53.1263 10.604C53.8823 10.184 54.7283 9.974 55.6643 9.974C56.6003 9.974 57.4463 10.184 58.2023 10.604C58.9583 11.012 59.5523 11.6 59.9843 12.368C60.4283 13.136 60.6503 14.03 60.6503 15.05C60.6503 16.07 60.4223 16.97 59.9663 17.75C59.5223 18.518 58.9163 19.112 58.1483 19.532C57.3803 19.952 56.5283 20.162 55.5923 20.162ZM55.5923 18.722C56.1803 18.722 56.7323 18.584 57.2483 18.308C57.7643 18.032 58.1783 17.618 58.4903 17.066C58.8143 16.514 58.9763 15.842 58.9763 15.05C58.9763 14.258 58.8203 13.586 58.5083 13.034C58.1963 12.482 57.7883 12.074 57.2843 11.81C56.7803 11.534 56.2343 11.396 55.6463 11.396C55.0463 11.396 54.4943 11.534 53.9903 11.81C53.4983 12.074 53.1023 12.482 52.8023 13.034C52.5023 13.586 52.3523 14.258 52.3523 15.05C52.3523 15.854 52.4963 16.532 52.7843 17.084C53.0843 17.636 53.4803 18.05 53.9723 18.326C54.4643 18.59 55.0043 18.722 55.5923 18.722ZM67.61 9.956C68.81 9.956 69.782 10.322 70.526 11.054C71.27 11.774 71.642 12.818 71.642 14.186V20H70.022V14.42C70.022 13.436 69.776 12.686 69.284 12.17C68.792 11.642 68.12 11.378 67.268 11.378C66.404 11.378 65.714 11.648 65.198 12.188C64.694 12.728 64.442 13.514 64.442 14.546V20H62.804V10.136H64.442V11.54C64.766 11.036 65.204 10.646 65.756 10.37C66.32 10.094 66.938 9.956 67.61 9.956ZM76.3156 11.486V17.3C76.3156 17.78 76.4176 18.122 76.6216 18.326C76.8256 18.518 77.1796 18.614 77.6836 18.614H78.8896V20H77.4136C76.5016 20 75.8176 19.79 75.3616 19.37C74.9056 18.95 74.6776 18.26 74.6776 17.3V11.486H73.3996V10.136H74.6776V7.652H76.3156V10.136H78.8896V11.486H76.3156ZM81.7203 8.534C81.4083 8.534 81.1443 8.426 80.9283 8.21C80.7123 7.994 80.6043 7.73 80.6043 7.418C80.6043 7.106 80.7123 6.842 80.9283 6.626C81.1443 6.41 81.4083 6.302 81.7203 6.302C82.0203 6.302 82.2723 6.41 82.4763 6.626C82.6923 6.842 82.8003 7.106 82.8003 7.418C82.8003 7.73 82.6923 7.994 82.4763 8.21C82.2723 8.426 82.0203 8.534 81.7203 8.534ZM82.5123 10.136V20H80.8743V10.136H82.5123ZM90.11 9.956C91.31 9.956 92.282 10.322 93.026 11.054C93.77 11.774 94.142 12.818 94.142 14.186V20H92.522V14.42C92.522 13.436 92.276 12.686 91.784 12.17C91.292 11.642 90.62 11.378 89.768 11.378C88.904 11.378 88.214 11.648 87.698 12.188C87.194 12.728 86.942 13.514 86.942 14.546V20H85.304V10.136H86.942V11.54C87.266 11.036 87.704 10.646 88.256 10.37C88.82 10.094 89.438 9.956 90.11 9.956ZM105.566 10.136V20H103.928V18.542C103.616 19.046 103.178 19.442 102.614 19.73C102.062 20.006 101.45 20.144 100.778 20.144C100.01 20.144 99.3196 19.988 98.7076 19.676C98.0956 19.352 97.6096 18.872 97.2496 18.236C96.9016 17.6 96.7276 16.826 96.7276 15.914V10.136H98.3476V15.698C98.3476 16.67 98.5936 17.42 99.0856 17.948C99.5776 18.464 100.25 18.722 101.102 18.722C101.978 18.722 102.668 18.452 103.172 17.912C103.676 17.372 103.928 16.586 103.928 15.554V10.136H105.566ZM117.331 14.69C117.331 15.002 117.313 15.332 117.277 15.68H109.393C109.453 16.652 109.783 17.414 110.383 17.966C110.995 18.506 111.733 18.776 112.597 18.776C113.305 18.776 113.893 18.614 114.361 18.29C114.841 17.954 115.177 17.51 115.369 16.958H117.133C116.869 17.906 116.341 18.68 115.549 19.28C114.757 19.868 113.773 20.162 112.597 20.162C111.661 20.162 110.821 19.952 110.077 19.532C109.345 19.112 108.769 18.518 108.349 17.75C107.929 16.97 107.719 16.07 107.719 15.05C107.719 14.03 107.923 13.136 108.331 12.368C108.739 11.6 109.309 11.012 110.041 10.604C110.785 10.184 111.637 9.974 112.597 9.974C113.533 9.974 114.361 10.178 115.081 10.586C115.801 10.994 116.353 11.558 116.737 12.278C117.133 12.986 117.331 13.79 117.331 14.69ZM115.639 14.348C115.639 13.724 115.501 13.19 115.225 12.746C114.949 12.29 114.571 11.948 114.091 11.72C113.623 11.48 113.101 11.36 112.525 11.36C111.697 11.36 110.989 11.624 110.401 12.152C109.825 12.68 109.495 13.412 109.411 14.348H115.639ZM137.432 10.136L134.354 20H132.662L130.286 12.17L127.91 20H126.218L123.122 10.136H124.796L127.064 18.416L129.512 10.136H131.186L133.58 18.434L135.812 10.136H137.432ZM139.904 8.534C139.592 8.534 139.328 8.426 139.112 8.21C138.896 7.994 138.788 7.73 138.788 7.418C138.788 7.106 138.896 6.842 139.112 6.626C139.328 6.41 139.592 6.302 139.904 6.302C140.204 6.302 140.456 6.41 140.66 6.626C140.876 6.842 140.984 7.106 140.984 7.418C140.984 7.73 140.876 7.994 140.66 8.21C140.456 8.426 140.204 8.534 139.904 8.534ZM140.696 10.136V20H139.058V10.136H140.696ZM145.486 11.486V17.3C145.486 17.78 145.588 18.122 145.792 18.326C145.996 18.518 146.35 18.614 146.854 18.614H148.06V20H146.584C145.672 20 144.988 19.79 144.532 19.37C144.076 18.95 143.848 18.26 143.848 17.3V11.486H142.57V10.136H143.848V7.652H145.486V10.136H148.06V11.486H145.486ZM154.94 9.956C155.684 9.956 156.356 10.118 156.956 10.442C157.556 10.754 158.024 11.228 158.36 11.864C158.708 12.5 158.882 13.274 158.882 14.186V20H157.262V14.42C157.262 13.436 157.016 12.686 156.524 12.17C156.032 11.642 155.36 11.378 154.508 11.378C153.644 11.378 152.954 11.648 152.438 12.188C151.934 12.728 151.682 13.514 151.682 14.546V20H150.044V6.68H151.682V11.54C152.006 11.036 152.45 10.646 153.014 10.37C153.59 10.094 154.232 9.956 154.94 9.956ZM175.861 11.09C175.513 10.358 175.009 9.794 174.349 9.398C173.689 8.99 172.921 8.786 172.045 8.786C171.169 8.786 170.377 8.99 169.669 9.398C168.973 9.794 168.421 10.37 168.013 11.126C167.617 11.87 167.419 12.734 167.419 13.718C167.419 14.702 167.617 15.566 168.013 16.31C168.421 17.054 168.973 17.63 169.669 18.038C170.377 18.434 171.169 18.632 172.045 18.632C173.269 18.632 174.277 18.266 175.069 17.534C175.861 16.802 176.323 15.812 176.455 14.564H171.451V13.232H178.201V14.492C178.105 15.524 177.781 16.472 177.229 17.336C176.677 18.188 175.951 18.866 175.051 19.37C174.151 19.862 173.149 20.108 172.045 20.108C170.881 20.108 169.819 19.838 168.859 19.298C167.899 18.746 167.137 17.984 166.573 17.012C166.021 16.04 165.745 14.942 165.745 13.718C165.745 12.494 166.021 11.396 166.573 10.424C167.137 9.44 167.899 8.678 168.859 8.138C169.819 7.586 170.881 7.31 172.045 7.31C173.377 7.31 174.553 7.64 175.573 8.3C176.605 8.96 177.355 9.89 177.823 11.09H175.861ZM184.668 20.162C183.744 20.162 182.904 19.952 182.148 19.532C181.404 19.112 180.816 18.518 180.384 17.75C179.964 16.97 179.754 16.07 179.754 15.05C179.754 14.042 179.97 13.154 180.402 12.386C180.846 11.606 181.446 11.012 182.202 10.604C182.958 10.184 183.804 9.974 184.74 9.974C185.676 9.974 186.522 10.184 187.278 10.604C188.034 11.012 188.628 11.6 189.06 12.368C189.504 13.136 189.726 14.03 189.726 15.05C189.726 16.07 189.498 16.97 189.042 17.75C188.598 18.518 187.992 19.112 187.224 19.532C186.456 19.952 185.604 20.162 184.668 20.162ZM184.668 18.722C185.256 18.722 185.808 18.584 186.324 18.308C186.84 18.032 187.254 17.618 187.566 17.066C187.89 16.514 188.052 15.842 188.052 15.05C188.052 14.258 187.896 13.586 187.584 13.034C187.272 12.482 186.864 12.074 186.36 11.81C185.856 11.534 185.31 11.396 184.722 11.396C184.122 11.396 183.57 11.534 183.066 11.81C182.574 12.074 182.178 12.482 181.878 13.034C181.578 13.586 181.428 14.258 181.428 15.05C181.428 15.854 181.572 16.532 181.86 17.084C182.16 17.636 182.556 18.05 183.048 18.326C183.54 18.59 184.08 18.722 184.668 18.722ZM196.182 20.162C195.258 20.162 194.418 19.952 193.662 19.532C192.918 19.112 192.33 18.518 191.898 17.75C191.478 16.97 191.268 16.07 191.268 15.05C191.268 14.042 191.484 13.154 191.916 12.386C192.36 11.606 192.96 11.012 193.716 10.604C194.472 10.184 195.318 9.974 196.254 9.974C197.19 9.974 198.036 10.184 198.792 10.604C199.548 11.012 200.142 11.6 200.574 12.368C201.018 13.136 201.24 14.03 201.24 15.05C201.24 16.07 201.012 16.97 200.556 17.75C200.112 18.518 199.506 19.112 198.738 19.532C197.97 19.952 197.118 20.162 196.182 20.162ZM196.182 18.722C196.77 18.722 197.322 18.584 197.838 18.308C198.354 18.032 198.768 17.618 199.08 17.066C199.404 16.514 199.566 15.842 199.566 15.05C199.566 14.258 199.41 13.586 199.098 13.034C198.786 12.482 198.378 12.074 197.874 11.81C197.37 11.534 196.824 11.396 196.236 11.396C195.636 11.396 195.084 11.534 194.58 11.81C194.088 12.074 193.692 12.482 193.392 13.034C193.092 13.586 192.942 14.258 192.942 15.05C192.942 15.854 193.086 16.532 193.374 17.084C193.674 17.636 194.07 18.05 194.562 18.326C195.054 18.59 195.594 18.722 196.182 18.722ZM207.462 9.974C208.314 9.974 209.058 10.16 209.694 10.532C210.342 10.904 210.822 11.372 211.134 11.936V10.136H212.79V20.216C212.79 21.116 212.598 21.914 212.214 22.61C211.83 23.318 211.278 23.87 210.558 24.266C209.85 24.662 209.022 24.86 208.074 24.86C206.778 24.86 205.698 24.554 204.834 23.942C203.97 23.33 203.46 22.496 203.304 21.44H204.924C205.104 22.04 205.476 22.52 206.04 22.88C206.604 23.252 207.282 23.438 208.074 23.438C208.974 23.438 209.706 23.156 210.27 22.592C210.846 22.028 211.134 21.236 211.134 20.216V18.146C210.81 18.722 210.33 19.202 209.694 19.586C209.058 19.97 208.314 20.162 207.462 20.162C206.586 20.162 205.788 19.946 205.068 19.514C204.36 19.082 203.802 18.476 203.394 17.696C202.986 16.916 202.782 16.028 202.782 15.032C202.782 14.024 202.986 13.142 203.394 12.386C203.802 11.618 204.36 11.024 205.068 10.604C205.788 10.184 206.586 9.974 207.462 9.974ZM211.134 15.05C211.134 14.306 210.984 13.658 210.684 13.106C210.384 12.554 209.976 12.134 209.46 11.846C208.956 11.546 208.398 11.396 207.786 11.396C207.174 11.396 206.616 11.54 206.112 11.828C205.608 12.116 205.206 12.536 204.906 13.088C204.606 13.64 204.456 14.288 204.456 15.032C204.456 15.788 204.606 16.448 204.906 17.012C205.206 17.564 205.608 17.99 206.112 18.29C206.616 18.578 207.174 18.722 207.786 18.722C208.398 18.722 208.956 18.578 209.46 18.29C209.976 17.99 210.384 17.564 210.684 17.012C210.984 16.448 211.134 15.794 211.134 15.05ZM217.196 6.68V20H215.558V6.68H217.196ZM228.988 14.69C228.988 15.002 228.97 15.332 228.934 15.68H221.05C221.11 16.652 221.44 17.414 222.04 17.966C222.652 18.506 223.39 18.776 224.254 18.776C224.962 18.776 225.55 18.614 226.018 18.29C226.498 17.954 226.834 17.51 227.026 16.958H228.79C228.526 17.906 227.998 18.68 227.206 19.28C226.414 19.868 225.43 20.162 224.254 20.162C223.318 20.162 222.478 19.952 221.734 19.532C221.002 19.112 220.426 18.518 220.006 17.75C219.586 16.97 219.376 16.07 219.376 15.05C219.376 14.03 219.58 13.136 219.988 12.368C220.396 11.6 220.966 11.012 221.698 10.604C222.442 10.184 223.294 9.974 224.254 9.974C225.19 9.974 226.018 10.178 226.738 10.586C227.458 10.994 228.01 11.558 228.394 12.278C228.79 12.986 228.988 13.79 228.988 14.69ZM227.296 14.348C227.296 13.724 227.158 13.19 226.882 12.746C226.606 12.29 226.228 11.948 225.748 11.72C225.28 11.48 224.758 11.36 224.182 11.36C223.354 11.36 222.646 11.624 222.058 12.152C221.482 12.68 221.152 13.412 221.068 14.348H227.296Z"
                                fill="#1F274A"
                              />
                            </svg>
                          </a>
                        </UserProvider>
                      </li>
                      <li>
                        <UserProvider>
                          <a
                            onClick={async () => {
                              const data = await facebookSignIn();
                              const url = `${config.api.base_url}patient/auth/sign-in?type=social`;
                              login(data);
                            }}
                            role="button"
                          >
                            <svg
                              width="253"
                              height="27"
                              viewBox="0 0 253 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M36.774 13.718C36.774 12.494 37.05 11.396 37.602 10.424C38.154 9.44 38.904 8.672 39.852 8.12C40.812 7.568 41.874 7.292 43.038 7.292C44.406 7.292 45.6 7.622 46.62 8.282C47.64 8.942 48.384 9.878 48.852 11.09H46.89C46.542 10.334 46.038 9.752 45.378 9.344C44.73 8.936 43.95 8.732 43.038 8.732C42.162 8.732 41.376 8.936 40.68 9.344C39.984 9.752 39.438 10.334 39.042 11.09C38.646 11.834 38.448 12.71 38.448 13.718C38.448 14.714 38.646 15.59 39.042 16.346C39.438 17.09 39.984 17.666 40.68 18.074C41.376 18.482 42.162 18.686 43.038 18.686C43.95 18.686 44.73 18.488 45.378 18.092C46.038 17.684 46.542 17.102 46.89 16.346H48.852C48.384 17.546 47.64 18.476 46.62 19.136C45.6 19.784 44.406 20.108 43.038 20.108C41.874 20.108 40.812 19.838 39.852 19.298C38.904 18.746 38.154 17.984 37.602 17.012C37.05 16.04 36.774 14.942 36.774 13.718ZM55.5923 20.162C54.6683 20.162 53.8283 19.952 53.0723 19.532C52.3283 19.112 51.7403 18.518 51.3083 17.75C50.8883 16.97 50.6783 16.07 50.6783 15.05C50.6783 14.042 50.8943 13.154 51.3263 12.386C51.7703 11.606 52.3703 11.012 53.1263 10.604C53.8823 10.184 54.7283 9.974 55.6643 9.974C56.6003 9.974 57.4463 10.184 58.2023 10.604C58.9583 11.012 59.5523 11.6 59.9843 12.368C60.4283 13.136 60.6503 14.03 60.6503 15.05C60.6503 16.07 60.4223 16.97 59.9663 17.75C59.5223 18.518 58.9163 19.112 58.1483 19.532C57.3803 19.952 56.5283 20.162 55.5923 20.162ZM55.5923 18.722C56.1803 18.722 56.7323 18.584 57.2483 18.308C57.7643 18.032 58.1783 17.618 58.4903 17.066C58.8143 16.514 58.9763 15.842 58.9763 15.05C58.9763 14.258 58.8203 13.586 58.5083 13.034C58.1963 12.482 57.7883 12.074 57.2843 11.81C56.7803 11.534 56.2343 11.396 55.6463 11.396C55.0463 11.396 54.4943 11.534 53.9903 11.81C53.4983 12.074 53.1023 12.482 52.8023 13.034C52.5023 13.586 52.3523 14.258 52.3523 15.05C52.3523 15.854 52.4963 16.532 52.7843 17.084C53.0843 17.636 53.4803 18.05 53.9723 18.326C54.4643 18.59 55.0043 18.722 55.5923 18.722ZM67.61 9.956C68.81 9.956 69.782 10.322 70.526 11.054C71.27 11.774 71.642 12.818 71.642 14.186V20H70.022V14.42C70.022 13.436 69.776 12.686 69.284 12.17C68.792 11.642 68.12 11.378 67.268 11.378C66.404 11.378 65.714 11.648 65.198 12.188C64.694 12.728 64.442 13.514 64.442 14.546V20H62.804V10.136H64.442V11.54C64.766 11.036 65.204 10.646 65.756 10.37C66.32 10.094 66.938 9.956 67.61 9.956ZM76.3156 11.486V17.3C76.3156 17.78 76.4176 18.122 76.6216 18.326C76.8256 18.518 77.1796 18.614 77.6836 18.614H78.8896V20H77.4136C76.5016 20 75.8176 19.79 75.3616 19.37C74.9056 18.95 74.6776 18.26 74.6776 17.3V11.486H73.3996V10.136H74.6776V7.652H76.3156V10.136H78.8896V11.486H76.3156ZM81.7203 8.534C81.4083 8.534 81.1443 8.426 80.9283 8.21C80.7123 7.994 80.6043 7.73 80.6043 7.418C80.6043 7.106 80.7123 6.842 80.9283 6.626C81.1443 6.41 81.4083 6.302 81.7203 6.302C82.0203 6.302 82.2723 6.41 82.4763 6.626C82.6923 6.842 82.8003 7.106 82.8003 7.418C82.8003 7.73 82.6923 7.994 82.4763 8.21C82.2723 8.426 82.0203 8.534 81.7203 8.534ZM82.5123 10.136V20H80.8743V10.136H82.5123ZM90.11 9.956C91.31 9.956 92.282 10.322 93.026 11.054C93.77 11.774 94.142 12.818 94.142 14.186V20H92.522V14.42C92.522 13.436 92.276 12.686 91.784 12.17C91.292 11.642 90.62 11.378 89.768 11.378C88.904 11.378 88.214 11.648 87.698 12.188C87.194 12.728 86.942 13.514 86.942 14.546V20H85.304V10.136H86.942V11.54C87.266 11.036 87.704 10.646 88.256 10.37C88.82 10.094 89.438 9.956 90.11 9.956ZM105.566 10.136V20H103.928V18.542C103.616 19.046 103.178 19.442 102.614 19.73C102.062 20.006 101.45 20.144 100.778 20.144C100.01 20.144 99.3196 19.988 98.7076 19.676C98.0956 19.352 97.6096 18.872 97.2496 18.236C96.9016 17.6 96.7276 16.826 96.7276 15.914V10.136H98.3476V15.698C98.3476 16.67 98.5936 17.42 99.0856 17.948C99.5776 18.464 100.25 18.722 101.102 18.722C101.978 18.722 102.668 18.452 103.172 17.912C103.676 17.372 103.928 16.586 103.928 15.554V10.136H105.566ZM117.331 14.69C117.331 15.002 117.313 15.332 117.277 15.68H109.393C109.453 16.652 109.783 17.414 110.383 17.966C110.995 18.506 111.733 18.776 112.597 18.776C113.305 18.776 113.893 18.614 114.361 18.29C114.841 17.954 115.177 17.51 115.369 16.958H117.133C116.869 17.906 116.341 18.68 115.549 19.28C114.757 19.868 113.773 20.162 112.597 20.162C111.661 20.162 110.821 19.952 110.077 19.532C109.345 19.112 108.769 18.518 108.349 17.75C107.929 16.97 107.719 16.07 107.719 15.05C107.719 14.03 107.923 13.136 108.331 12.368C108.739 11.6 109.309 11.012 110.041 10.604C110.785 10.184 111.637 9.974 112.597 9.974C113.533 9.974 114.361 10.178 115.081 10.586C115.801 10.994 116.353 11.558 116.737 12.278C117.133 12.986 117.331 13.79 117.331 14.69ZM115.639 14.348C115.639 13.724 115.501 13.19 115.225 12.746C114.949 12.29 114.571 11.948 114.091 11.72C113.623 11.48 113.101 11.36 112.525 11.36C111.697 11.36 110.989 11.624 110.401 12.152C109.825 12.68 109.495 13.412 109.411 14.348H115.639ZM137.432 10.136L134.354 20H132.662L130.286 12.17L127.91 20H126.218L123.122 10.136H124.796L127.064 18.416L129.512 10.136H131.186L133.58 18.434L135.812 10.136H137.432ZM139.904 8.534C139.592 8.534 139.328 8.426 139.112 8.21C138.896 7.994 138.788 7.73 138.788 7.418C138.788 7.106 138.896 6.842 139.112 6.626C139.328 6.41 139.592 6.302 139.904 6.302C140.204 6.302 140.456 6.41 140.66 6.626C140.876 6.842 140.984 7.106 140.984 7.418C140.984 7.73 140.876 7.994 140.66 8.21C140.456 8.426 140.204 8.534 139.904 8.534ZM140.696 10.136V20H139.058V10.136H140.696ZM145.486 11.486V17.3C145.486 17.78 145.588 18.122 145.792 18.326C145.996 18.518 146.35 18.614 146.854 18.614H148.06V20H146.584C145.672 20 144.988 19.79 144.532 19.37C144.076 18.95 143.848 18.26 143.848 17.3V11.486H142.57V10.136H143.848V7.652H145.486V10.136H148.06V11.486H145.486ZM154.94 9.956C155.684 9.956 156.356 10.118 156.956 10.442C157.556 10.754 158.024 11.228 158.36 11.864C158.708 12.5 158.882 13.274 158.882 14.186V20H157.262V14.42C157.262 13.436 157.016 12.686 156.524 12.17C156.032 11.642 155.36 11.378 154.508 11.378C153.644 11.378 152.954 11.648 152.438 12.188C151.934 12.728 151.682 13.514 151.682 14.546V20H150.044V6.68H151.682V11.54C152.006 11.036 152.45 10.646 153.014 10.37C153.59 10.094 154.232 9.956 154.94 9.956ZM173.449 7.454V8.786H167.995V13.016H172.423V14.348H167.995V20H166.357V7.454H173.449ZM174.815 15.032C174.815 14.024 175.019 13.142 175.427 12.386C175.835 11.618 176.393 11.024 177.101 10.604C177.821 10.184 178.619 9.974 179.495 9.974C180.359 9.974 181.109 10.16 181.745 10.532C182.381 10.904 182.855 11.372 183.167 11.936V10.136H184.823V20H183.167V18.164C182.843 18.74 182.357 19.22 181.709 19.604C181.073 19.976 180.329 20.162 179.477 20.162C178.601 20.162 177.809 19.946 177.101 19.514C176.393 19.082 175.835 18.476 175.427 17.696C175.019 16.916 174.815 16.028 174.815 15.032ZM183.167 15.05C183.167 14.306 183.017 13.658 182.717 13.106C182.417 12.554 182.009 12.134 181.493 11.846C180.989 11.546 180.431 11.396 179.819 11.396C179.207 11.396 178.649 11.54 178.145 11.828C177.641 12.116 177.239 12.536 176.939 13.088C176.639 13.64 176.489 14.288 176.489 15.032C176.489 15.788 176.639 16.448 176.939 17.012C177.239 17.564 177.641 17.99 178.145 18.29C178.649 18.578 179.207 18.722 179.819 18.722C180.431 18.722 180.989 18.578 181.493 18.29C182.009 17.99 182.417 17.564 182.717 17.012C183.017 16.448 183.167 15.794 183.167 15.05ZM186.979 15.05C186.979 14.03 187.183 13.142 187.591 12.386C187.999 11.618 188.563 11.024 189.283 10.604C190.015 10.184 190.849 9.974 191.785 9.974C192.997 9.974 193.993 10.268 194.773 10.856C195.565 11.444 196.087 12.26 196.339 13.304H194.575C194.407 12.704 194.077 12.23 193.585 11.882C193.105 11.534 192.505 11.36 191.785 11.36C190.849 11.36 190.093 11.684 189.517 12.332C188.941 12.968 188.653 13.874 188.653 15.05C188.653 16.238 188.941 17.156 189.517 17.804C190.093 18.452 190.849 18.776 191.785 18.776C192.505 18.776 193.105 18.608 193.585 18.272C194.065 17.936 194.395 17.456 194.575 16.832H196.339C196.075 17.84 195.547 18.65 194.755 19.262C193.963 19.862 192.973 20.162 191.785 20.162C190.849 20.162 190.015 19.952 189.283 19.532C188.563 19.112 187.999 18.518 187.591 17.75C187.183 16.982 186.979 16.082 186.979 15.05ZM207.525 14.69C207.525 15.002 207.507 15.332 207.471 15.68H199.587C199.647 16.652 199.977 17.414 200.577 17.966C201.189 18.506 201.927 18.776 202.791 18.776C203.499 18.776 204.087 18.614 204.555 18.29C205.035 17.954 205.371 17.51 205.563 16.958H207.327C207.063 17.906 206.535 18.68 205.743 19.28C204.951 19.868 203.967 20.162 202.791 20.162C201.855 20.162 201.015 19.952 200.271 19.532C199.539 19.112 198.963 18.518 198.543 17.75C198.123 16.97 197.913 16.07 197.913 15.05C197.913 14.03 198.117 13.136 198.525 12.368C198.933 11.6 199.503 11.012 200.235 10.604C200.979 10.184 201.831 9.974 202.791 9.974C203.727 9.974 204.555 10.178 205.275 10.586C205.995 10.994 206.547 11.558 206.931 12.278C207.327 12.986 207.525 13.79 207.525 14.69ZM205.833 14.348C205.833 13.724 205.695 13.19 205.419 12.746C205.143 12.29 204.765 11.948 204.285 11.72C203.817 11.48 203.295 11.36 202.719 11.36C201.891 11.36 201.183 11.624 200.595 12.152C200.019 12.68 199.689 13.412 199.605 14.348H205.833ZM211.325 11.972C211.661 11.384 212.153 10.904 212.801 10.532C213.449 10.16 214.187 9.974 215.015 9.974C215.903 9.974 216.701 10.184 217.409 10.604C218.117 11.024 218.675 11.618 219.083 12.386C219.491 13.142 219.695 14.024 219.695 15.032C219.695 16.028 219.491 16.916 219.083 17.696C218.675 18.476 218.111 19.082 217.391 19.514C216.683 19.946 215.891 20.162 215.015 20.162C214.163 20.162 213.413 19.976 212.765 19.604C212.129 19.232 211.649 18.758 211.325 18.182V20H209.687V6.68H211.325V11.972ZM218.021 15.032C218.021 14.288 217.871 13.64 217.571 13.088C217.271 12.536 216.863 12.116 216.347 11.828C215.843 11.54 215.285 11.396 214.673 11.396C214.073 11.396 213.515 11.546 212.999 11.846C212.495 12.134 212.087 12.56 211.775 13.124C211.475 13.676 211.325 14.318 211.325 15.05C211.325 15.794 211.475 16.448 211.775 17.012C212.087 17.564 212.495 17.99 212.999 18.29C213.515 18.578 214.073 18.722 214.673 18.722C215.285 18.722 215.843 18.578 216.347 18.29C216.863 17.99 217.271 17.564 217.571 17.012C217.871 16.448 218.021 15.788 218.021 15.032ZM226.153 20.162C225.229 20.162 224.389 19.952 223.633 19.532C222.889 19.112 222.301 18.518 221.869 17.75C221.449 16.97 221.239 16.07 221.239 15.05C221.239 14.042 221.455 13.154 221.887 12.386C222.331 11.606 222.931 11.012 223.687 10.604C224.443 10.184 225.289 9.974 226.225 9.974C227.161 9.974 228.007 10.184 228.763 10.604C229.519 11.012 230.113 11.6 230.545 12.368C230.989 13.136 231.211 14.03 231.211 15.05C231.211 16.07 230.983 16.97 230.527 17.75C230.083 18.518 229.477 19.112 228.709 19.532C227.941 19.952 227.089 20.162 226.153 20.162ZM226.153 18.722C226.741 18.722 227.293 18.584 227.809 18.308C228.325 18.032 228.739 17.618 229.051 17.066C229.375 16.514 229.537 15.842 229.537 15.05C229.537 14.258 229.381 13.586 229.069 13.034C228.757 12.482 228.349 12.074 227.845 11.81C227.341 11.534 226.795 11.396 226.207 11.396C225.607 11.396 225.055 11.534 224.551 11.81C224.059 12.074 223.663 12.482 223.363 13.034C223.063 13.586 222.913 14.258 222.913 15.05C222.913 15.854 223.057 16.532 223.345 17.084C223.645 17.636 224.041 18.05 224.533 18.326C225.025 18.59 225.565 18.722 226.153 18.722ZM237.667 20.162C236.743 20.162 235.903 19.952 235.147 19.532C234.403 19.112 233.815 18.518 233.383 17.75C232.963 16.97 232.753 16.07 232.753 15.05C232.753 14.042 232.969 13.154 233.401 12.386C233.845 11.606 234.445 11.012 235.201 10.604C235.957 10.184 236.803 9.974 237.739 9.974C238.675 9.974 239.521 10.184 240.277 10.604C241.033 11.012 241.627 11.6 242.059 12.368C242.503 13.136 242.725 14.03 242.725 15.05C242.725 16.07 242.497 16.97 242.041 17.75C241.597 18.518 240.991 19.112 240.223 19.532C239.455 19.952 238.603 20.162 237.667 20.162ZM237.667 18.722C238.255 18.722 238.807 18.584 239.323 18.308C239.839 18.032 240.253 17.618 240.565 17.066C240.889 16.514 241.051 15.842 241.051 15.05C241.051 14.258 240.895 13.586 240.583 13.034C240.271 12.482 239.863 12.074 239.359 11.81C238.855 11.534 238.309 11.396 237.721 11.396C237.121 11.396 236.569 11.534 236.065 11.81C235.573 12.074 235.177 12.482 234.877 13.034C234.577 13.586 234.427 14.258 234.427 15.05C234.427 15.854 234.571 16.532 234.859 17.084C235.159 17.636 235.555 18.05 236.047 18.326C236.539 18.59 237.079 18.722 237.667 18.722ZM250.386 20L246.516 15.644V20H244.878V6.68H246.516V14.51L250.314 10.136H252.6L247.956 15.05L252.618 20H250.386Z"
                                fill="#1F274A"
                              />
                              <g clip-path="url(#clip0_2495_3727)">
                                <path
                                  d="M10.5 24C16.299 24 21 19.299 21 13.5C21 7.70101 16.299 3 10.5 3C4.70101 3 0 7.70101 0 13.5C0 19.299 4.70101 24 10.5 24Z"
                                  fill="#3C5A9A"
                                />
                                <path
                                  d="M13.9145 6.22266H11.5885C10.2082 6.22266 8.67297 6.80321 8.67297 8.80409C8.67971 9.50128 8.67297 10.169 8.67297 10.9204H7.07617V13.4615H8.72239V20.777H11.7474V13.4133H13.744L13.9246 10.9133H11.6953C11.6953 10.9133 11.7003 9.8012 11.6953 9.47824C11.6953 8.68754 12.518 8.73282 12.5675 8.73282C12.959 8.73282 13.7202 8.73396 13.9156 8.73282V6.22266H13.9145Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_2495_3727">
                                  <rect
                                    width="21"
                                    height="21"
                                    fill="white"
                                    transform="translate(0 3)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </a>
                        </UserProvider>
                      </li>
                    </ul>
                  </Form.Item>
                  {/* </div> */}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-10 col-md-10 col-12 text-center">
                  <Form.Item className="regitLableBottom mb-0">
                    Don't have an account?{" "}
                    <Xlink to="registeration/register">Sign Up</Xlink>
                  </Form.Item>
                </div>
              </div>
            </Form>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
            <img
              className="img-fix-login"
              src={process.env.PUBLIC_URL + "/images/svg/loginImg.svg"}
              alt=""
            />
          </div>
        </div>
      </div>
      <Modal
        title="Forgot Password?"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        className="ModalHeader"
      >
        {!resetNumber ? (
          <>
            Please enter the phone number associated with your account and we'll
            send an email with OTP to reset your password.
            <Form
              style={{ textAlign: "center" }}
              form={PasswordForm}
              onFinish={() => {
                console.log("s0", passwordData);
                if (!passwordData.otp.length > 0) {
                  notification["error"]({
                    message: "Please enter your OTP",
                    placement: "bottomRight",
                  });
                } else {
                  ConfirmOtp(passwordData.username, passwordData.otp);
                }
              }}
            >
              <Form.Item
                name="mobile"
                rules={[
                  {
                    required: true,
                    message: "Please enter phone number",
                  },
                  () => ({
                    validator(_, value) {
                      if (!value || value.match(/^[6-9]\d{9}$/)) {
                        setValidated(true);
                        return Promise.resolve().then(function (value) {
                          //console.log(value, 'success')
                        });
                      }
                      setValidated(false);
                      return Promise.reject(
                        new Error("Please enter valid phone number")
                      );
                    },
                  }),
                ]}
              >
                <Input
                  addonBefore="+91"
                  maxLength={10}
                  size="large"
                  placeholder="Mobile Number"
                  style={{ paddingTop: "20px" }}
                  type="number"
                  // name="phoneInput"
                  onChange={(e) =>
                    setPasswordData({
                      ...passwordData,
                      ["username"]: e.target.value,
                    })
                  }
                />
              </Form.Item>

              {sendResponse && sendResponse.statusCode === 200 ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    {/*<OTPInput onChange={(e) => {*/}
                    {/*    let tempPassWordData = {...passwordData}*/}
                    {/*     let tempData = [...tempPassWordData.otp.slice(0,0),...tempPassWordData.otp.slice(1)]*/}
                    {/*                tempPassWordData.otp = e.target.value*/}
                    {/*    setPasswordData(tempPassWordData)*/}
                    {/*    //  passwordData.otp.splice(0, 0, e.target.value)*/}
                    {/*    }} type={"text"} id='otp1' maxLength={1} onKeyUp={(e) => move(e, "","otp1", "otp2" )}/> */}
                    {/*<OTPInput onChange={(e) => {*/}
                    {/*         let tempPassWordData = {...passwordData}*/}
                    {/*         let tempData = [...tempPassWordData.otp.slice(0,1),...tempPassWordData.otp.slice(2)]*/}
                    {/*         tempPassWordData.otp =  e.target.value*/}
                    {/*         setPasswordData(tempPassWordData)*/}
                    {/*}} value={passwordData.otp[1]} type={"text"} id='otp2' maxLength={1} onKeyUp={(e) => move(e, "otp1","otp2", "otp3" )}/> */}
                    {/*<OTPInput onChange={(e) => {*/}
                    {/*         let tempPassWordData = {...passwordData}*/}
                    {/*         let tempData = [...tempPassWordData.otp.slice(0,2),...tempPassWordData.otp.slice(3)]*/}
                    {/*                tempPassWordData.otp = e.target.value*/}
                    {/*         setPasswordData(tempPassWordData)*/}
                    {/*}} value={passwordData.otp[2]} type={"text"} id='otp3' maxLength={1} onKeyUp={(e) => move(e, "otp2","otp3", "otp4" )}/> */}
                    {/*<OTPInput onChange={(e) => {*/}
                    {/*         let tempPassWordData = {...passwordData}*/}
                    {/*         let tempData = [...tempPassWordData.otp.slice(0,3),...tempPassWordData.otp.slice(4)]*/}
                    {/*                tempPassWordData.otp = e.target.value*/}
                    {/*         setPasswordData(tempPassWordData)*/}
                    {/*}} value={passwordData.otp[3]} type={"text"} id='otp4' maxLength={1} onKeyUp={(e) => move(e, "otp3","otp4", "" )}/> */}
                    <OTPInput
                      onChange={(e) =>
                        passwordData.otp.splice(0, 0, e.target.value)
                      }
                      type={"text"}
                      id="otp1"
                      maxLength={1}
                      onKeyUp={(e) => move(e, "", "otp1", "otp2")}
                    />
                    <OTPInput
                      onChange={(e) =>
                        passwordData.otp.splice(1, 0, e.target.value)
                      }
                      value={passwordData.otp[1]}
                      type={"text"}
                      id="otp2"
                      maxLength={1}
                      onKeyUp={(e) => move(e, "otp1", "otp2", "otp3")}
                    />
                    <OTPInput
                      onChange={(e) =>
                        passwordData.otp.splice(2, 0, e.target.value)
                      }
                      value={passwordData.otp[2]}
                      type={"text"}
                      id="otp3"
                      maxLength={1}
                      onKeyUp={(e) => move(e, "otp2", "otp3", "otp4")}
                    />
                    <OTPInput
                      onChange={(e) =>
                        passwordData.otp.splice(3, 0, e.target.value)
                      }
                      value={passwordData.otp[3]}
                      type={"text"}
                      id="otp4"
                      maxLength={1}
                      onKeyUp={(e) => move(e, "otp3", "otp4", "")}
                    />
                    <div>
                      <Button
                        onClick={ResendOtp}
                        disabled={resetEnable}
                        type="link"
                      >
                        Resend OTP?
                      </Button>
                      <span style={{ color: "green", fontWeight: "bold" }}>
                        {" "}
                        00:{counter}{" "}
                      </span>
                      <br />
                    </div>
                  </div>
                  <Button
                    size="large"
                    shape="round"
                    type="primary"
                    htmlType="submit"
                    className="themeBtn"
                  >
                    {" "}
                    Confirm OTP{" "}
                  </Button>
                </>
              ) : (
                <Button
                  size="large"
                  shape="round"
                  type="primary"
                  onClick={SendOTP}
                  disabled={!validated}
                  className="themeBtn"
                  style={{ cursor: `${validated ? "pointer" : "not-allowed"}` }}
                >
                  Send OTP
                </Button>
              )}
            </Form>
          </>
        ) : (
          <>
            <Form onFinish={SetPassword}>
              <Form.Item
                name="Password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                  () => ({
                    validator(_, value) {
                      console.log(value);
                      if (
                        !value ||
                        value.match(
                          /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z]).{8,}$/
                        )
                      ) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "Please enter Password with minimum 8 characters, one lowercase, one number and an special character"
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  className="inputBox"
                  onChange={(e) =>
                    setPasswordData({
                      ...passwordData,
                      ["newPassword"]: e.target.value,
                    })
                  }
                  style={{ borderRadius: "5px" }}
                />
              </Form.Item>
              <Form.Item
                name="confirm"
                dependencies={["Password"]}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Please confirm your password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      {
                        console.log(getFieldValue("Password"), value);
                      }
                      if (!value || getFieldValue("Password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Password and confirm password must be same.")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  className="inputBox"
                  style={{ borderRadius: "5px" }}
                />
              </Form.Item>
              <Button
                size="large"
                shape="round"
                type="primary"
                htmlType="submit"
                className="themeBtn"
              >
                Reset Password
              </Button>
            </Form>
          </>
        )}
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loginState: state.login,
  saveLoginDataState: state.saveLoginData,
  // sendForgotPasswordOtpState: state.sendForgotPasswordOtp,
});

const mapDispatchToProps = (dispatch) => ({
  login: (params) => dispatch(login(params)),
  saveLoginData: (params) => dispatch(saveLoginData(params)),
  // sendForgotPasswordOtp: (params) => dispatch(sendForgotPasswordOtp(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
